import {createFileRoute} from '@tanstack/react-router'

import SegmentsScreen from '@protected/segments'

export const Route = createFileRoute('/_protected/segments')({component: SegmentsScreen})
